import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconOpenAi16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconOpenAi16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M13.209 6.912a2.96 2.96 0 0 0-.26-2.456 3.08 3.08 0 0 0-3.301-1.45A3.05 3.05 0 0 0 7.363 2 3.06 3.06 0 0 0 4.44 4.093a3.03 3.03 0 0 0-2.026 1.45A2.99 2.99 0 0 0 2.79 9.09a2.95 2.95 0 0 0 .26 2.455 3.08 3.08 0 0 0 3.3 1.45A3.05 3.05 0 0 0 8.638 14a3.06 3.06 0 0 0 2.924-2.095 3.03 3.03 0 0 0 2.026-1.45 2.99 2.99 0 0 0-.378-3.544m-4.571 6.304a2.3 2.3 0 0 1-1.46-.52l.072-.04 2.422-1.38c.124-.07.2-.2.2-.341V7.566l1.023.583a.04.04 0 0 1 .02.028v2.79c-.002 1.24-1.02 2.246-2.277 2.249M3.74 11.152a2.2 2.2 0 0 1-.272-1.507l.072.043 2.422 1.38c.122.07.275.07.398 0l2.956-1.685v1.167a.04.04 0 0 1-.014.03l-2.448 1.395a2.3 2.3 0 0 1-3.114-.823m-.637-5.216A2.26 2.26 0 0 1 4.29 4.95l-.001.083v2.76a.39.39 0 0 0 .198.34l2.957 1.684-1.024.583a.04.04 0 0 1-.034.003L3.937 9.007a2.235 2.235 0 0 1-.834-3.07m8.409 1.931L8.556 6.183 9.58 5.6a.04.04 0 0 1 .034-.003l2.448 1.394a2.233 2.233 0 0 1 .834 3.073 2.27 2.27 0 0 1-1.185.986V8.207a.39.39 0 0 0-.198-.34m1.018-1.513-.072-.042-2.421-1.38a.4.4 0 0 0-.398 0L6.683 6.616V5.45q0-.02.015-.031l2.448-1.394a2.296 2.296 0 0 1 3.113.825c.265.455.361.987.271 1.504zM6.127 8.433 5.103 7.85a.04.04 0 0 1-.02-.028v-2.79c.001-1.242 1.022-2.248 2.281-2.247.532 0 1.048.184 1.457.52l-.072.04-2.421 1.38c-.124.07-.2.2-.2.34zm.556-1.183L8 6.5l1.317.75v1.5L8 9.5l-1.317-.75z"
            />
        </svg>
    );
}
export default memo(IconOpenAi16);
